import { Grid } from "@material-ui/core";
import React from "react";
import { Text, Button, Modal } from "sunrise-ui";
import Menu from "@material-ui/core/Menu";

//------for api call------
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../redux/store";
import {
  getAllProjectData,
  deleteProjectData,
} from "../../redux/reducers/projectReducers";
import { uiSliceActions } from "../../redux/reducers/uiState";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "../../utilities/Loader";
import NoDataScreen from "../../utilities/NoDataScreen";
import List from "../../utilities/List";

const useStylesForPopUp = makeStyles({
  customWidth: {
    "& .MuiMenu-list": {
      width: "260px",
      border: "1px solid #5F67E0",
      borderRadius: "4px",
    },
  },
});

const ManageProject = () => {
  const dispatch = useDispatch<AppDispatch>();
  // -----------loader state------------
  let [loading, setLoading] = React.useState(false);
  //---to get all projects detail----
  React.useEffect(() => {
    setLoading(true);
    dispatch(getAllProjectData({ endPoint: "project/get-all-projects" })).then(
      (res) => {
        setLoading(false);
      }
    );
  }, [dispatch]);
  const allProjectData = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );

  //-----modal state--------
  const [open, setOpen] = React.useState(false);
  const [modalText, setModalText] = React.useState("");
  const [handleCallData, setHandleCallData] = React.useState({
    type: "",
    projectID: "",
    projectDetail: {},
  });

  const [dataToDownload, setDataToDownload]: any = React.useState([]);

  //---------for pilesteps popup------
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [popUpData, setPopUpData] = React.useState([]);
  const classes = useStylesForPopUp();

  React.useEffect(() => {
    const downloadData = allProjectData?.map((val: any) => {
      // const workOrderLength = val?.workOrderInformation.workOrderItemDetails.length;
      const nullRemover = (item: any) => {
        return item === null ? "" : item;
      };
      return {
        "Project Name": nullRemover(val?.projectName),
        "Project City": nullRemover(val?.projectCity),
        "Main Contractor Name": nullRemover(val?.mainContractor),
        "Client Name": nullRemover(val?.clientInfo),
        "Type Of Project": nullRemover(val?.type),
        "Project Start Date": nullRemover(val?.startDate),
        "Expected Completion Date": nullRemover(val?.expectedEndDate),
        "Description": nullRemover(val?.description),
        "Work Order Issue Date": nullRemover(val?.workOrderInformation?.issuedDate),

        // "Work Order Item Details": nullRemover(val?.workOrderInformation.workOrderItemDetails[workOrderLength - 1]?.name),
        // "Quantity of Items": nullRemover(val?.workOrderInformation.workOrderItemDetails[workOrderLength - 1]?.quantity),
        // "Unit of Items": nullRemover(val?.workOrderInformation.workOrderItemDetails[workOrderLength - 1]?.unit),
        // "Rate (Rs)": nullRemover(val?.workOrderInformation.workOrderItemDetails[workOrderLength - 1]?.rate),
        // "Basic Amount (Rs)": nullRemover(val?.workOrderInformation.workOrderItemDetails[workOrderLength - 1]?.basicAmount),

        "Total Work Order Value (Rs)": nullRemover(val?.workOrderInformation?.workOrderValue),
        "Total Pile Length To Be Filled (m)": nullRemover(val?.workOrderInformation?.workOrderValue),

      };
    });
    setDataToDownload(downloadData);
  }, [allProjectData]);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    data: any
  ) => {
    setAnchorEl(event.currentTarget);
    setPopUpData(data);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //------modal handler
  const handleModal = (type: string, projectID: string, projectDetail: any) => {
    setOpen(true);
    if (type === "edit") {
      setHandleCallData({
        type: type,
        projectID: projectID,
        projectDetail: {
          ...projectDetail,
          type:
            projectDetail.type[0].toUpperCase() + projectDetail.type.slice(1),
        },
      });
      setModalText("Are you sure you want to edit this project?");
    } else {
      setHandleCallData({
        type: type,
        projectID: projectID,
        projectDetail: projectDetail,
      });
      setModalText(
        "Please make sure you have unassigned all the things from this project, Are you sure you want to remove this project?"
      );
    }
  };
  //----modal YES button handler
  const handleCall = () => {
    if (handleCallData?.type === "remove") {
      setOpen(false);
      dispatch(
        deleteProjectData({
          endPoint: `project/delete-project/${handleCallData?.projectID}`,
        })
      );
      setTimeout(function () {
        setLoading(true);
        dispatch(
          getAllProjectData({ endPoint: "project/get-all-projects" })
        ).then((res) => {
          setLoading(false);
        });
      }, 1000);
    } else if (handleCallData?.type === "edit") {
      setOpen(false);
      dispatch(uiSliceActions.setFirst(handleCallData));
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  const viewPdf = function (obj: any) {
    return (
      <Grid>
        <Text
          fonts="normal"
          onTextClick={() => { }}
          type="link"
          fontSize={14}
          className="mb1 mt0 fw500"
        >
          {obj?.workOrderInformation?.workOrderDoc?.slice(
            22
          )}
        </Text>
      </Grid>
    )
  }

  const viewPileStep = function (obj: any) {
    return (
      <Grid>
        <Text
          fonts="normal"
          aria-controls="pileSteps-menu"
          aria-haspopup="true"
          onTextClick={(e) => {
            handleClick(e, obj?.pileInformation);
          }}
          type="link"
          fontSize={14}
          className="mb1 mt0 fw500"
        >
          View Pile Steps
        </Text>
      </Grid>
    )
  }

  const actionButtons = function (obj: any) {
    return (
      <Grid className="action_buttons_box d-flex v-center">
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="primary"
          onClick={() => {
            handleModal("edit", obj?._id, obj);
          }}
          className="mr-1 f14"
        >
          Edit
        </Button>
        <Button
          type="button"
          size="medium"
          isRounded={true}
          category="warning"
          onClick={() => {
            handleModal("remove", obj?._id, obj);
          }}
          className="mr-1 f14"
        >
          Remove
        </Button>
      </Grid>
    );
  };

  const fields = [
    { header: "Project Name", value: "projectName", search: true },
    { header: "Project City", value: "projectCity", search: true },
    { header: "Main Contractor Name", value: "mainContractor", search: true },
    { header: "Client Name", value: "clientInfo", search: true },
    { header: "Type Of Project", value: "type", search: true },
    { header: "Project Start Date", value: "startDate", search: true, format: 'date' },
    { header: "Expected Completion Date", value: "expectedEndDate", search: true, format: 'date' },
    { header: "Description", value: "description", search: true },
    { header: "Work Order Issue Date", value: "workOrderInformation.issuedDate", search: true, format: 'date' },
    {
      value: "workOrderInformation.workOrderItemDetails",
      subList: [
        { header: "Work Order Item Details", value: "name", isSelector: true },
        { header: "Quantity of Items", value: "quantity" },
        { header: "Unit of Items", value: "unit" },
        { header: "Rate (Rs)", value: "rate" },
        { header: "Basic Amount (Rs)", value: "basicAmount" }
      ],
    },
    { header: "Total Work Order Value (Rs)", value: "workOrderInformation.workOrderValue" },
    { header: "Total Pile Length To Be Filled (m)", value: "workOrderInformation.totalPileLength" },
    { header: "Uploaded WO Pdf", action: viewPdf },
    { header: "Pile Steps", action: viewPileStep },
    { header: "Action", action: actionButtons },
  ];

  //---to handle select box data in table----
  const initialItemState: any[] =
    allProjectData &&
    allProjectData?.map((item: any) => ({
      quantity: "",
      unit: "",
      rate: "",
      basicAmount: "",
    }));
  const [rowsItem, setRowsItem] = React.useState([...initialItemState]);
  React.useEffect(() => {
    if (rowsItem.length === 0) {
      setRowsItem([...initialItemState]);
    }
    return;
  }, [initialItemState, rowsItem.length]);

  return (
    <>
      {loading ? (
        <Loader color="#5f67e0" loading={loading} size={20} height="80vh" />
      ) : (
        <Grid
          container
          className="box--shadow bg--white p1 mt1 mb1 manage_project"
        >
          <Grid item xs={12}>
            {allProjectData.length > 0 ? (
              <List
                listData={allProjectData}
                fields={fields}
                title={"Manage Projects"}
                dataToDownload={dataToDownload}
                isOverflow
              />
            ) : (
              <NoDataScreen text="No projects are created to manage, create projects to manage." />
            )}
          </Grid>
          {/* -------modal---- */}
          <Grid item xs={12}>
            <Modal
              image="modalImage"
              call={() => {
                handleCall();
              }}
              reset={() => {
                setOpen(false);
              }}
              openModal={open}
              title={modalText}
              showImageModal={false}
            />
          </Grid>
          {/* ------popup to show pile steps detail---- */}
          <Grid item xs={12}>
            <Menu
              id="pileSteps-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
              className={classes.customWidth}
            >
              <Grid container className="p">
                <Grid item xs={4}>
                  <Text
                    fonts="normal"
                    type="normal"
                    fontSize={13}
                    className="mb mt0 fw500"
                  >
                    Step Details
                  </Text>
                </Grid>
                <Grid item xs={4}>
                  <Text
                    fonts="normal"
                    type="normal"
                    fontSize={13}
                    className="mb mt0 fw500"
                  >
                    Weightage %
                  </Text>
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={12}>
                  {popUpData?.map((item: any) => {
                    return (
                      <Grid container>
                        <Grid item xs={5}>
                          <Text
                            fonts="normal"
                            type="normal"
                            fontSize={13}
                            className="mb mt0 fw300 capitalize"
                          >
                            {item.stepNumber}&nbsp;
                            {item.stepName}
                          </Text>
                        </Grid>
                        <Grid item xs={3}>
                          <Text
                            fonts="normal"
                            type="normal"
                            fontSize={13}
                            className="mb mt0 fw300"
                          >
                            {item.weightageOfStartingPoint}/
                            {item.weightageOfEndingPoint}
                          </Text>
                        </Grid>
                        <Grid item xs={4}>
                          <Text
                            fonts="normal"
                            type="normal"
                            fontSize={13}
                            className="mb mt0 fw300"
                          >
                            {item.isMandatory === true
                              ? "Mandatory"
                              : "Optional"}
                          </Text>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
            </Menu>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ManageProject;
